__webpack_require__.p = "/reports-spinner-mintime/referrals-hub/";